import HyperlinkContainer from './HyperlinkContainer'

export default HyperlinkContainer
